import { tryToJsonParse } from "src/utils";
import { capitalize } from '../utils/index';
import { SingleValue } from "react-select";

export class AiAgent {
    id!: number;
    name: string = '';
    private source: string = '';
    private vectorstore: string = '';
    context: string = 'Chat History:\n' +
        '{chat_history}\n' +
        'Follow Up Input: {input}';
    chat_history_context: string = 'Given the following conversation and a follow up question, rephrase the follow up question to be a standalone question.\nChat History:\n{chat_history}\nFollow Up Input: {input}\nStandalone Question:';
    private knowledge: string = '';
    private url_audio: string = '';
    private url_video: string = '';
    private url_web: string = '';
    greeting_message: string = '["Hola, ¿En que puedo ayudarte?"]';
    suggested_message: string = '[]';
    avatar: string = '';
    agent_name: string = '';
    title: string = '';
    background_user_color: string = '#ffffff';
    text_user_color: string = '#000000';
    background_agent_color: string = '#16aaff';
    text_agent_color: string = '#ffffff';
    button_color: string = '#3f6ad8';
    private circular_alignment: string = 'bottomRight';
    private enable: boolean = false;
    created_at: string = '';
    updated_at: string = '';

    constructor(aiAgent: Partial<AiAgent>) {
        Object.assign(this, aiAgent);
    }

    public setName(name: string) {
        this.name = name;
    }

    public getSelectModel() {
        return {label: capitalize(this.source), value: capitalize(this.source)};
    }

    public setSelectModel(option: SingleValue<{
        label: string;
        value: string;
    }>) {
        if(option) {
            this.source = option.value;
        }
    }

    public getSelectVectorStore() {
        return {label: this.vectorstore === "Pinecone" ? "Vectorstore  Database" : capitalize(this.vectorstore), value: capitalize(this.vectorstore)};
    }

    public setSelectVectorStore(option: SingleValue<{
        label: string;
        value: string;
    }>) {
        if(option) {
            this.vectorstore = option.value;
        }
    }

    public setContext(data: string) {
        this.context = data;
    }

    public setChatHistoryContext(data: string) {
        this.chat_history_context = data;
    }

    public getUrlVideo(): string[] {
        if(this.url_video) {
            return tryToJsonParse(this.url_video);
        }
        return [];
    }

    public setUrlVideo(array: string[]) {
        if(array) {
            this.url_video = JSON.stringify(array);
        }
    }

    public getUrlAudio(): string[] {
        if(this.url_audio) {
            return tryToJsonParse(this.url_audio);
        }
        return [];
    }

    public setUrlAudio(array: string[]) {
        if(array) {
            this.url_audio = JSON.stringify(array);
        }
    }

    public getUrlWeb(): string[] {
        if(this.url_web) {
            return tryToJsonParse(this.url_web);
        }
        return [];
    }

    public setUrlWeb(array: string[]) {
        if(array) {
            this.url_web = JSON.stringify(array);
        }
    }

    public setAvatar(data: string) {
        this.avatar = data;
    }

    public getGreetingMessage(): string[] {
        if(this.greeting_message) {
            return tryToJsonParse(this.greeting_message);
        }
        return [];
    }

    public setGreetingMessage(array: string[]) {
        if(array) {
            this.greeting_message = JSON.stringify(array);
        }
    }

    public getSuggestedMessage(): string[] {
        if(this.suggested_message) {
            return tryToJsonParse(this.suggested_message);
        }
        return [];
    }

    public setSuggestedMessage(array: string[]) {
        if(array) {
            this.suggested_message = JSON.stringify(array);
        }
    }

    public setAgentName(data: string) {
        this.agent_name = data;
    }

    public setTitle(data: string) {
        this.title = data;
    }

    public setBackgroundUserColor(data: string) {
        this.background_user_color = data;
    }

    public setTextUserColor(data: string) {
        this.text_user_color = data;
    }

    public setBackgroundAgentColor(data: string) {
        this.background_agent_color = data;
    }

    public setTextAgentColor(data: string) {
        this.text_agent_color = data;
    }

    public setButtonColor(data: string) {
        this.button_color = data;
    }

    public getSelectCircularAlignment() {
        return {label: capitalize(this.circular_alignment), value: capitalize(this.circular_alignment)};
    }

    public setSelectCircularAlignment(option: SingleValue<{
        label: string;
        value: string;
    }>) {
        if(option) {
            this.circular_alignment = option.value;
        }
    }

    public getKnowledge() {
        return this.knowledge;
    }

    public setKnowledge(knowledge: string) {
        this.knowledge = knowledge;
    }

    public getEnable() {
        return this.enable;
    }

    public setEnable() {
        this.enable = !this.enable;
    }
}